import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags } from '../../../../redux/DefaultModelActions';
import { APIBase, APIPost } from '../../../../services/API';

const model = 'View';
const route = '/v1/view';

export const searchViews = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const createView = (args) => createModel(model, route, args);
export const updateView = (id, args) => updateModel(model, route, id, args);
export const deleteView = (id) => deleteModel(model, route, id);
export const restoreView = (id) => restoreModel(model, route, id);
export const getView = (id) => getModel(model, route, id);
export const getViewRevision = (id) => getRevisions(model, route, id);
export const duplicateView = (id) => duplicateModel(model, route, id);